import MultistepWizard from './multistep-wizard.js';

class MultistepWizardHipotecas extends MultistepWizard {
  constructor() {
    super()
    this.isNotFirstProperty = false
    this.tasacionInput = null
    this.solicitadoInput = null
    this.plazoInput = null
    this.stepFinalidad = null
    this.stepImporteSolicitado = null
    this.stepPhone = null
    this.porcentajeSolicitado = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.setupHipotecas()
    this.showStep(this.findStep('start') || this.findStep('finalidad'))
  }

  setupHipotecas() {
    this.tasacionInput = this.querySelector('#captador_simulacion_valor_tasacion')
    this.solicitadoInput = this.querySelector('#captador_simulacion_importe_solicitado')
    this.porcentajeMaximoSugerido = this.solicitadoInput.dataset.porcentajeFinanciacionMaximo
    this.plazoInput = this.querySelector('#captador_simulacion_plazo_anyos')
    this.fechaPrevista = this.querySelector('#captador_simulacion_fecha_prevista')
    this.stepFinalidad = this.querySelector('multistep-step[position="finalidad"]')
    this.stepImporteSolicitado = this.querySelector('multistep-step[position="importe_solicitado"]')
    this.pendienteInput = this.querySelector('#captador_simulacion_importe_pendiente_amortizar')
    this.stepPhone = this.querySelector('multistep-step[position="telefono"]')
    this.maxPercentage = this.isNotFirstProperty ? 70 : 90
    this.phoneTitle = this.stepPhone?.querySelector('.rnk-WizardStep_titulo')
    this.phoneTitleAlternative = this.stepPhone?.querySelector('.rnk-WizardStep_titulo-alternative')
    this.phoneDescriptionAlternative = this.stepPhone?.querySelector('.rnk-WizardStep_explicacion-alternative')

    this.solicitadoRange = document.createElement('INPUT')
    this.solicitadoHelperNode = document.createElement('SMALL')
    this.plazoRange = this.plazoInput.hasAttribute('max') ? document.createElement('INPUT') : undefined
    this.plazoHelperNode = document.createElement('SMALL')

    // Setup nodes
    this.tasacionInput.min = 1000
    this.tasacionInput.step = 1
    this.solicitadoInput.step = 1
    this.solicitadoInput.min = 1000
    this.solicitadoRange.type = 'range'
    this.solicitadoRange.step = 1
    this.solicitadoRange.min = 1000
    this.solicitadoRange.value = this.solicitadoRange.min
    this.solicitadoHelperNode.innerHTML = `Te recomendamos solicitar como máximo el ${this.porcentajeMaximoSugerido}% del valor de tasación.`
    if (this.plazoRange) {
      this.plazoRange.type = 'range'
      this.plazoRange.step = 1
      this.plazoRange.min = this.plazoInput.min
      this.plazoRange.max = this.plazoInput.max
    }

    // Insert nodes on document
    this.solicitadoInput.parentNode.insertBefore(this.solicitadoRange, this.solicitadoInput.nextElementSibling)
    this.solicitadoInput.closest('multistep-step').querySelector('header').appendChild(this.solicitadoHelperNode)
    this.plazoInput.closest('multistep-step').querySelector('header').appendChild(this.plazoHelperNode)
    this.plazoInput?.parentNode.insertBefore(this.plazoRange, this.plazoInput.nextElementSibling)

    // Add listeners
    this.stepFinalidad.addEventListener('change', this.onFinalidadChanged.bind(this))
    this.tasacionInput.addEventListener('input', this.onTasacionChanged.bind(this))
    this.solicitadoInput.addEventListener('input', this.onSolicitadoChanged.bind(this))
    this.plazoInput.addEventListener('input', this.onPlazoChanged.bind(this))
    this.stepImporteSolicitado.addEventListener('hide', this.onStepImporteSolicitadoHide.bind(this))

    for (let evento of ['input', 'change', 'mousemove', 'touchmove']) {
      this.solicitadoRange.addEventListener(evento, this.onSolicitadoRangeChanged.bind(this))
      this.plazoRange?.addEventListener(evento, this.onPlazoRangeChanged.bind(this))
    }

    // Required on retries
    const inputs = [
      this.pendienteInput,
      this.tasacionInput,
      this.solicitadoInput,
      this.solicitadoRange,
      this.plazoInput,
      this.fechaPrevista
    ]
    inputs.forEach(input => {
      if (input?.value) input.dispatchEvent(new CustomEvent('input'))
    })

    this.onFinalidadChanged()
  }

  updateHelper(input, helper, defaultTip) {
    if (input.validationMessage) { // on error
      helper.style.color = '#da4a33'
      helper.innerHTML = input.validationMessage
    } else {
      helper.style.color = '#428cc3'
      helper.innerHTML = defaultTip || '&nbsp;'
    }
  }

  updatePhoneTextHelper () {
    if (document.documentElement.lang.endsWith('-es')) {
      if (!Number.isFinite(this.porcentajeSolicitado) || this.porcentajeSolicitado === 0 || this.stepPhone === null) return

      if (this.porcentajeSolicitado >= this.maxPercentage) {
        this.phoneTitle.classList.add('hidden')
        this.phoneTitleAlternative.classList.remove('hidden')
        this.phoneDescriptionAlternative.classList.remove('hidden')
      } else {
        this.phoneTitle.classList.remove('hidden')
        this.phoneTitleAlternative.classList.add('hidden')
        this.phoneDescriptionAlternative.classList.add('hidden')
      }
    }
  }

  onFinalidadChanged() {
    if (document.documentElement.lang.endsWith('-es')){
      const formData = new FormData(this.querySelector('form'))
      const selectedValue = formData.get('captador_simulacion[finalidad]')
      if (selectedValue === null) return

      const solicitadoDescription = this.stepImporteSolicitado.querySelector('.rnk-WizardStep_explicacion')
      const solicitadoDescriptionAlternative = this.stepImporteSolicitado.querySelector('.rnk-WizardStep_explicacion-alternative')
      if (selectedValue === 'Comprar segunda vivienda' || selectedValue === 'Invertir') {
        this.isNotFirstProperty = true
        solicitadoDescription.classList.add('hidden')
        solicitadoDescriptionAlternative.classList.remove('hidden')
      } else {
        this.isNotFirstProperty = false
        solicitadoDescription.classList.remove('hidden')
        solicitadoDescriptionAlternative.classList.add('hidden')
      }
      this.maxPercentage = this.isNotFirstProperty ? 70 : 90
    }
  }
  onStepImporteSolicitadoHide(){
    this.porcentajeSolicitado = Math.floor(this.solicitadoInput.valueAsNumber / this.tasacionInput.valueAsNumber * 100)
    this.updatePhoneTextHelper(this.porcentajeSolicitado)
  }

  onTasacionChanged() {
    const max = this.tasacionInput.valueAsNumber
    const maxSugerido = Math.floor(this.tasacionInput.valueAsNumber * parseInt(this.porcentajeMaximoSugerido) / 100)

    this.solicitadoInput.max = max
    this.solicitadoInput.value = maxSugerido
    this.solicitadoInput.dispatchEvent(new CustomEvent('input'))
    this.solicitadoRange.max = max
    this.solicitadoRange.value = maxSugerido
    this.solicitadoRange.dispatchEvent(new CustomEvent('input'))
  }

  onSolicitadoChanged() {
    const porcentajeActual = Math.floor(this.solicitadoInput.valueAsNumber / this.tasacionInput.valueAsNumber * 100)
    const helperText = `Estarías solicitando una financiación del <b>${porcentajeActual}%</b> .`

    this.porcentajeSolicitado = porcentajeActual
    this.solicitadoRange.value = this.solicitadoInput.valueAsNumber
    this.updateHelper(this.solicitadoInput, this.solicitadoHelperNode, helperText)
    this.updatePhoneTextHelper()
  }

  onSolicitadoRangeChanged () {
    if (this.solicitadoRange.valueAsNumber < parseInt(this.solicitadoRange.max)) {
      // emulate a step of 100 while lower than max
      // (so, admit hundreds and the max value)
      this.solicitadoRange.value = Math.ceil(this.solicitadoRange.valueAsNumber / 100) * 100
    }
    this.solicitadoInput.value = this.solicitadoRange.value
    this.solicitadoInput.dispatchEvent(new CustomEvent('input'))
  }

  onPlazoChanged() {
    if (this.plazoRange) this.plazoRange.value = this.plazoInput.valueAsNumber
    this.updateHelper(this.plazoInput, this.plazoHelperNode, '')
  }

  onPlazoRangeChanged() {
    this.plazoInput.value = this.plazoRange?.value
    this.plazoInput.dispatchEvent(new CustomEvent('input'))
  }

  // Override to avoid scroll to top
  scrollToTop() {}
}

export default MultistepWizardHipotecas;
